module.exports = __webpack_public_path__ + "img/buwang.92e81730.jpg";